import {H, P, ViewCopy, ViewDialog} from "../components/view.tsx";
import NumberInput from "../components/inputs/input-number.tsx";
import { Button } from "../components/button.tsx";
import {ReactNode, useEffect, useContext, useState} from "react";
import { useStore } from "../state/state.ts";
import { PdfLink } from "../components/pdf-link.tsx";
import PropertyInput from "../components/inputs/input-property.tsx";
import { format_1000 } from "../functions.ts";
import { ConfigContext } from "../config_context.ts";
import { FundingsList } from "../components/fundings_list.tsx";
import "./view_calculation.css"
import TabLink from "../components/tab-link.tsx";
import { OutlookPeriod } from "../state/types.ts";
import ModalInfoPeriode from "../modals/modal_info_periode.tsx";
import InfoButton from "../components/inputs/info-button.tsx";
import { PeriodSlider } from "../components/inputs/period_slider.tsx";

export default function ViewCalculation() {
  //const [period, setPeriod] = useState<OutlookPeriod>('now');

  const period_month = useStore((state)=>state.period_month); 
  const period_year = useStore((state)=>state.period_year); 
  const set_period = useStore((state)=>state.set_period); 


  const foerderung = useContext(ConfigContext).foerderung;
  const show_funding_list = useContext(ConfigContext).show_funding_list;

  const savings_percentage = useStore((state)=>state.savings_percentage); 
  const monthly_possible_savings = useStore((state)=>state.monthly_possible_savings); 
  const period_under_review_savings = useStore((state)=>state.period_under_review_savings); 
  const annual_energy_consumption_kwh_current = useStore((state)=>state.annual_energy_consumption_kwh_current); 
  const annual_energy_consumption_kwh_planned = useStore((state)=>state.annual_energy_consumption_kwh_planned); 
  const energy_efficiency_class_current = useStore((state)=>state.energy_efficiency_class_current); 
  const energy_efficiency_class_planned = useStore((state)=>state.energy_efficiency_class_planned); 
  const co2_emission_current = useStore((state)=>state.co2_emission_current); 
  const co2_emission_planned = useStore((state)=>state.co2_emission_planned); 
  
  const total_planned_costs = useStore((state)=>state.total_planned_costs); 
  const total_possible_subsidy = useStore((state)=>state.total_possible_subsidy); 

  const annual_savings_on_energy_costs = useStore((state)=>state.annual_savings_on_energy_costs); 
  const total_investment_costs = useStore((state)=>state.total_investment_costs); 
  const total_beg_subsidy = useStore((state)=>state.total_beg_subsidy); 
  const total_final_costs = useStore((state)=>state.total_final_costs); 

  const co2_tax_savings = useStore((state)=>state.co2_tax_savings); 
  const savings_over_lifetime = useStore((state)=>state.savings_over_lifetime); 

  const payback_period = useStore((state)=>state.payback_period);
  const annual_profit_loss = useStore((state)=>state.annual_profit_loss);
  const monthly_profit_loss = useStore((state)=>state.monthly_profit_loss);
  const kostensteigerung_energie = useStore((state)=>state.kostensteigerung_energie);
  const period_under_review_energy_savings = useStore((state)=>state.period_under_review_energy_savings);

  const co2_price = useStore((state)=>state.co2_price);

  const pv_area = useStore((state)=>state.pv?.area);
  const pv_elec_annual_savings = useStore((state)=>state.pv?.elec_annual_savings);
  const pv_elec_self_consumption = useStore((state)=>state.pv?.elec_self_consumption);
  const annual_pv_production_kwh_adjusted = useStore((state)=>state.annual_pv_production_kwh_adjusted ?? 0);
  const annual_pv_production_kwh_planned = useStore((state)=>state.annual_pv_production_kwh_planned ?? 0);

  const api_profitability_calculation = useStore((state)=>state.api_profitability_calculation);
  const profitability_outlook = useStore((state)=>state.profitability_outlook);

  const return_on_investment = useStore((state)=>state.return_on_investment);
  
  const include_in_print = useStore((state)=>state.include_in_print);
  const fundings_list = useStore((state)=>state.fundings_list);

  const questionizer_open_print_view = useStore((state)=>state.questionizer_open_print_view);

  useEffect(()=>{
    api_profitability_calculation();
  },[kostensteigerung_energie, co2_price]);

  const included_in_print_count = Object.keys(include_in_print).filter((key) => include_in_print[key]).length;
  const fundings_list_count = fundings_list ? fundings_list.length : 0;

  return (<ViewDialog>
            <ViewCopy><H>Ergebnisse und Einsparungen im Überblick</H><P>So rechnen sich die simulierten Sanierungen: Die Investitionskosten und {foerderung ? "eine mögliche Bundesförderung sowie die" : ""} Einsparpotentiale von Energie und CO2-Steuer – alle Ergebnisse auf einem Blick.</P></ViewCopy>
            {foerderung && <PeriodSlider/>}
           
            <div role="tabpanel">
            </div>
            <div className="calc_view">
              <table 
                className="table"
                role="table"
                aria-rowcount={3}>
                <tbody>
                  <TableRow><D>Investitionskosten gesamt</D><D>{format_1000(Math.round(profitability_outlook['now'].total_investment_costs + profitability_outlook['now'].total_beg_subsidy))} €</D></TableRow>
                  {foerderung && <TableRow><D>BEG-Förderung gesamt</D><D>{format_1000(Math.round(profitability_outlook['now'].total_beg_subsidy))} €</D></TableRow>}
                  {foerderung && <TableRow><D>Investition nach Förderung</D><D>{format_1000(Math.round(profitability_outlook['now'].total_investment_costs))} €</D></TableRow>}                
                </tbody>
              </table>

              <br/>

              <PropertyInput placeholder_prefix="ca." type="kostensteigerung_energie"/>
              <table 
                className="table"
                role="table"
                aria-rowcount={2}
                >
                <tbody>     
                  <TableRow><D>Gewinn / Verlust (im 1. Jahr)</D><D>
                    <div className="td-two">
                      <div><span>monatlich</span><span>{format_1000(profitability_outlook['now'].monthly_profit_loss  || 0)}  €</span></div> 
                      <div><span>jährlich</span><span>{format_1000(profitability_outlook['now'].annual_profit_loss || 0)} €</span></div> 
                    </div>
                  </D></TableRow>
                  <TableRow><D>Einsparungen Energiekosten*</D><D>{format_1000(profitability_outlook['now'].period_under_review_energy_savings || 0)} €</D></TableRow>
                </tbody> 
              </table>

              <br/>

               { (annual_pv_production_kwh_adjusted || annual_pv_production_kwh_planned) ? <>
                <table className="table">
                    <tbody>     
                      <TableRow><D>verschattungsfreie Dachfläche</D><D>min. {format_1000(pv_area || 0)} m²</D></TableRow>
                      <TableRow><D>Produktion PV-Strom</D><D>{format_1000(annual_pv_production_kwh_planned || annual_pv_production_kwh_adjusted || 0)} kWh/Jahr</D></TableRow>
                      <TableRow><D>Eigenverbrauch</D><D>{format_1000(pv_elec_self_consumption || 0)} kWh/Jahr</D></TableRow>
                      <TableRow><D>jährliche Einsparung Photovoltaik</D><D>{format_1000(pv_elec_annual_savings || 0)} €</D></TableRow>
                    </tbody>
                  </table>
                  <br/>
                  </> : []
              }

              <PropertyInput placeholder_prefix="ca." type="co2_price"/>
              <table 
                className="table"
                role="table"
                aria-rowcount={1}>
                <tbody>
                  <TableRow><D>CO₂-Steuerersparnis</D><D>{format_1000(profitability_outlook['now'].co2_tax_savings ||  0)} €</D></TableRow>
                </tbody>
              </table>

              <br/>

              <table 
                className="table"
                role="table"
                aria-rowcount={3}
                >
                <tbody>
                  {payback_period && <TableRow><D>Amortisationsdauer</D><D>{format_1000(profitability_outlook['now'].payback_period)} Jahre</D></TableRow>}
                  <TableRow><D>mittlere Rendite</D><D>{format_1000(profitability_outlook['now'].return_on_investment ||  0)} %</D></TableRow>
                  <TableRow><D>Einsparung gesamt*</D><D>{format_1000(profitability_outlook['now'].savings_over_lifetime ||  0)}  €</D></TableRow>
                </tbody>
              </table>

              <p className="input_hint">
                  *) über die Nutzungsdauer von 40 Jahren <br/>
                     die Nutzungsdauer bei Heizung, Solar, Photovoltaik und Lüftung beträgt ca. 20 Jahre
                </p>
                <div style={{height: "2rem"}}></div>
            </div>
            { show_funding_list && <FundingsList/> }
            { (show_funding_list &&  fundings_list_count > 0 ) && <Button disabled={included_in_print_count == 0} label="Förderprogramme anzeigen" style={{marginLeft:"auto", marginBottom: "1rem"}} onClick={()=>{
              questionizer_open_print_view()
            }}/> }

            <PdfLink/>
            <TabLink jump_to_id="new-button"/>
         </ViewDialog>)
}


export function TableRow(props:{children: ReactNode}) {
  return <tr role="row">
            <td role="cell">{props.children[0]}</td>
            <td role="cell">{props.children[1]}</td>
         </tr> 
}

export function D(props:{children: ReactNode}) {
  return <span>{props.children}</span>
}


